import {
  Directive,
  Output,
  HostListener,
  EventEmitter, AfterContentInit
} from '@angular/core';

export interface IWidthResizeEvent {
  width: number;
  isMobile: boolean;
}

@Directive({
  standalone: false,
  selector: '[resize]'
})
export class ResizeDirective implements AfterContentInit {

  @Output() onResize = new EventEmitter<IWidthResizeEvent>();

  constructor() {
  }

  @HostListener('window:resize', ['$event'])
  handleResize(event) {
    const width = event.target.innerWidth;
    this.onResize.emit({
      width,
      isMobile: width < 768
    });
  }

  ngAfterContentInit(): void {
    this.handleResize({ target: window });
  }
}
